import React from 'react';

import typ from './index.d';
import {
  DocumentArea,
  DocumentButton,
  DocumentIcon,
  DocumentInput,
  Image,
  ImageArea,
  ImageInput,
  Modal,
  PdfTitle,
  PhotoIcon,
} from './styles';
import { TitleSection } from '../../modal/styles';
import InputComponent from '../../input';
import EmptyImage from 'assets/images/empty-image.webp';
import InputSelectComponent from '../../input-select';
import { CONST_OCCUPATION } from '../../../utils/CONSTANTS';
import { toast } from 'react-toastify';
import { TalentPoolCRUD } from '../../../services/requests/talent-pool';
import { ApplicantCRUD } from '../../../services/requests/applicant';

const talentPoolCRUD = new TalentPoolCRUD();
const applicantCRUD = new ApplicantCRUD();

const CandidateModal: React.FC<typ.Props> = ({
  onClose,
  talentPool,
  isApplicant,
  corporateClientId
}) => {
  
  // Refs
  const inputImageRef = React.useRef<HTMLInputElement>(null);

  // States
  const [img, setImg] = React.useState(talentPool?.image || '');
  const [imageBase64, setImageBase64] = React.useState<any>(talentPool?.image);

  const [name, setName] = React.useState(talentPool?.name || '');
  const [mail, setMail] = React.useState(talentPool?.email || '');
  const [local, setLocal] = React.useState(talentPool?.local || '');
  const [occupation, setOccupation] = React.useState(
    talentPool?.occupation || '',
  );
  const [payment, setPayment] = React.useState(talentPool?.budget || '');

  const [warning, setWarning] = React.useState({
    name: false,
    mail: false,
    local: false,
    payment: false,
    occupation: false,
  });

  // TalentPool Callbacks
  const createTalentPool = React.useCallback(
    async (
      name: string,
      mail: string,
      local: string,
      occupation: string,
      payment: string,
      image: any,
    ) => {
      try {
        if (!name && !mail && !local && !occupation && !payment) {
          setWarning({
            mail: true,
            name: true,
            local: true,
            payment: true,
            occupation: true,
          });
          toast('Digite os campos corretamente.');
          return;
        }
        if (!name) {
          setWarning(e => ({ ...e, name: true }));
          toast('Digite o nome.');
          return;
        }
        if (!mail) {
          setWarning(e => ({ ...e, mail: true }));
          toast('Digite o email.');
          return;
        }
        if (!mail.includes('@')) {
          toast('Digite o email corretamente');
          setWarning(e => ({ ...e, mail: true }));
          return;
        }
        if (!local) {
          setWarning(e => ({ ...e, local: true }));
          toast('Digite o local.');
          return;
        }
        if (!occupation) {
          setWarning(e => ({ ...e, occupation: true }));
          toast('Selecione o cargo.');
          return;
        }

        if (!payment) {
          setWarning(e => ({ ...e, payment: true }));
          toast('Digite a remuneração.');
          return;
        }

        const { data, status, error } = await talentPoolCRUD.create({
          name,
          email: mail,
          budget: payment,
          local,
          occupation,
          image,
        });

        if (error) throw new Error(error.message.description);

        if (status === 200) {
          toast('Cliente criado com sucesso.');
          onClose();
        }
      } catch (e) {
        alert(e);
      }
    },
    [],
  );
  const editTalentPool = React.useCallback(
    async (
      name: string,
      mail: string,
      local: string,
      occupation: string,
      payment: string,
      image: any,
    ) => {
      try {
        if (!mail.includes('@')) {
          toast('Digite o email corretamente');
          setWarning(e => ({ ...e, mail: true }));
          return;
        }

        if (!name && !mail && !local && !occupation && !payment) {
          setWarning({
            mail: true,
            name: true,
            local: true,
            payment: true,
            occupation: true,
          });
          toast('Digite os campos corretamente.');
          return;
        }
        if (!name) {
          setWarning(e => ({ ...e, name: true }));
          toast('Digite o nome.');
          return;
        }
        if (!mail) {
          setWarning(e => ({ ...e, mail: true }));
          toast('Digite o email.');
          return;
        }
        if (!mail.includes('@')) {
          toast('Digite o email corretamente');
          setWarning(e => ({ ...e, mail: true }));
          return;
        }
        if (!local) {
          setWarning(e => ({ ...e, local: true }));
          toast('Digite o local.');
          return;
        }
        if (!occupation) {
          setWarning(e => ({ ...e, occupation: true }));
          toast('Selecione o cargo.');
          return;
        }

        if (!payment) {
          setWarning(e => ({ ...e, payment: true }));
          toast('Digite a remuneração.');
          return;
        }


        let currentOccupation: string;

        if (CONST_OCCUPATION.findIndex(item => item.label === occupation) >= 0) {
          currentOccupation =
            CONST_OCCUPATION[
              CONST_OCCUPATION.findIndex(item => item.label === occupation)
            ].keys;
        } else {
          currentOccupation = occupation;
        }

        const { status, error } = await talentPoolCRUD.update({
          name,
          email: mail,
          budget: payment,
          local,
          occupation: currentOccupation,
          image,
          id: talentPool?.id || 0,
        });
        if (error) throw new Error(error.message.description);
        if (status === 200) {
          onClose();
          toast('Cliente editado com sucesso.');
        }
      } catch (e) {
        alert(e);
      }
    },
    [],
  );

  // Applicant Callbacks
  const createApplicant = React.useCallback(
    async (
      name: string,
      mail: string,
      local: string,
      occupation: string,
      payment: string,
      image: any,
    ) => {
      try {
        if (!name && !mail && !local && !occupation && !payment) {
          setWarning({
            mail: true,
            name: true,
            local: true,
            payment: true,
            occupation: true,
          });
          toast('Digite os campos corretamente.');
          return;
        }
        if (!name) {
          setWarning(e => ({ ...e, name: true }));
          toast('Digite o nome.');
          return;
        }
        if (!mail) {
          setWarning(e => ({ ...e, mail: true }));
          toast('Digite o email.');
          return;
        }
        if (!mail.includes('@')) {
          toast('Digite o email corretamente');
          setWarning(e => ({ ...e, mail: true }));
          return;
        }
        if (!local) {
          setWarning(e => ({ ...e, local: true }));
          toast('Digite o local.');
          return;
        }
        if (!occupation) {
          setWarning(e => ({ ...e, occupation: true }));
          toast('Selecione o cargo.');
          return;
        }

        if (!payment) {
          setWarning(e => ({ ...e, payment: true }));
          toast('Digite a remuneração.');
          return;
        }

        const { data, status, error } = await applicantCRUD.create({
          name,
          email: mail,
          budget: payment,
          local,
          occupation,
          image,
          corporate_client_id: corporateClientId || '0'
        });

        if (error) throw new Error(error.message.description);

        if (status === 200) {
          toast('Cliente criado com sucesso.');
          onClose();
        }
      } catch (e) {
        alert(e);
      }
    },
    [],
  );
  const editApplicant = React.useCallback(
    async (
      id: number,
      name: string,
      mail: string,
      local: string,
      occupation: string,
      payment: string,
      image: any,
    ) => {
      try {
        if (!name && !mail && !local && !occupation && !payment) {
          setWarning({
            mail: true,
            name: true,
            local: true,
            payment: true,
            occupation: true,
          });
          toast('Digite os campos corretamente.');
          return;
        }
        if (!name) {
          setWarning(e => ({ ...e, name: true }));
          toast('Digite o nome.');
          return;
        }
        if (!mail) {
          setWarning(e => ({ ...e, mail: true }));
          toast('Digite o email.');
          return;
        }
        if (!mail.includes('@')) {
          toast('Digite o email corretamente');
          setWarning(e => ({ ...e, mail: true }));
          return;
        }
        if (!local) {
          setWarning(e => ({ ...e, local: true }));
          toast('Digite o local.');
          return;
        }
        if (!occupation) {
          setWarning(e => ({ ...e, occupation: true }));
          toast('Selecione o cargo.');
          return;
        }

        if (!payment) {
          setWarning(e => ({ ...e, payment: true }));
          toast('Digite a remuneração.');
          return;
        }

        let currentOccupation: string;

        if (
          CONST_OCCUPATION.findIndex(
            item => item.label.toLowerCase() === occupation.toLocaleLowerCase(),
          ) >= 0
        ) {
          currentOccupation =
            CONST_OCCUPATION[
              CONST_OCCUPATION.findIndex(
                item =>
                  item.label.toLowerCase() === occupation.toLocaleLowerCase(),
              )
            ].keys;
        } else {
          currentOccupation = occupation;
        }
        const { data, status, error } = await applicantCRUD.update({
          id,
          name,
          email: mail,
          budget: payment,
          local,
          occupation: currentOccupation,
          image,
        });

        if (error) throw new Error(error.message.description);

        if (status === 200) {
          toast('Cliente criado com sucesso.');
          onClose();
        }
      } catch (e) {
        alert(e);
      }
    },
    [],
  );

  return (
    <Modal
      modalTitle={`${talentPool ? 'Editar' : 'Novo'} cliente`}
      onClose={onClose}
      buttonCallback={() => {
        if (isApplicant) {
          if (talentPool) {
            editApplicant(
              talentPool.id,
              name,
              mail,
              local,
              occupation,
              payment,
              imageBase64,
            );

            return;
          }
          createApplicant(
            name,
            mail,
            local,
            occupation,
            payment,
            imageBase64,
          );
          return;
        }
        if (talentPool) {
          editTalentPool(
            name,
            mail,
            local,
            occupation,
            payment,
            imageBase64,
          );
          return;
        }
        createTalentPool(
          name,
          mail,
          local,
          occupation,
          payment,
          imageBase64,
        );
      }}>
      <ImageInput
        type="file"
        accept="image/*"
        ref={inputImageRef}
        onChange={event => {
          if (event && event.target?.files?.[0]) {
            const file = event.target.files[0];

            const reader = new FileReader();
            reader.onloadend = () => {
              setImageBase64(reader.result);
            };
            reader.readAsDataURL(file);
            setImg(URL.createObjectURL(event.target.files[0]));
          }
        }}
      />

      <ImageArea onClick={() => inputImageRef.current?.click()}>
        <Image src={img ? img : EmptyImage} />
        <PhotoIcon />
      </ImageArea>

      <TitleSection>Dados Pessoais</TitleSection>
      <InputComponent
        placeholder="Nome"
        type="text"
        value={name}
        setValue={setName}
        customStyle={{ marginBottom: 14 }}
        warning={warning.name}
      />
      <InputComponent
        placeholder="Email"
        type="email"
        value={mail}
        setValue={setMail}
        customStyle={{ marginBottom: 14 }}
        warning={warning.mail}
      />
      <InputComponent
        placeholder="Local"
        type="text"
        value={local}
        setValue={setLocal}
        customStyle={{ marginBottom: 0 }}
        warning={warning.local}
      />

      <TitleSection>Dados Profissionais</TitleSection>
      <DocumentArea>
        <InputSelectComponent
          type="text"
          placeholder="Ocupação"
          value={occupation}
          setValue={setOccupation}
          selectData={CONST_OCCUPATION}
          customStyle={{
            marginBottom: 18,
            background: '#fff',
          }}
          warning={warning.occupation}
        />
      </DocumentArea>
      <InputComponent
        placeholder="Remuneração"
        type="number"
        value={payment}
        setValue={setPayment}
        warning={warning.payment}
      />
    </Modal>
  );
};

export default CandidateModal;
